module.exports = __webpack_public_path__ + "img/1538457686.bdcef50c.jpg";